var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollElement",class:[
    'scroll-fade-in',
    `fade-${_vm.direction}`,
    { 'is-visible': _vm.isVisible }
  ],style:(_vm.customStyles)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }